// @flow
import * as React from 'react';
import {
    Box, Button, Text, TextInput, DropButton,
} from 'grommet';
import { FormSubtract } from 'grommet-icons';
import { FormattedMessage } from 'react-intl';

import RequiredAsterisk from 'speed-js-react-web/src/components/grommet2/forms/RequiredAsterisk';
import { ChromePicker } from 'react-color';


type FiberComponentProps = {
    tubeIndex: number,
    fiber: Fiber,
    fiberIndex: number,
    removeFiberFromTube: Function,
    changeFiberColor: Function,
    changeFiberStripeCount: Function,
}
const CableFiberColorSchemeField = ({
    tubeIndex, fiber, fiberIndex, removeFiberFromTube, changeFiberColor, changeFiberStripeCount,
}: FiberComponentProps) => {
    // Local state to keep track of the selected color, since we only update it once the dialog is closed
    const [selectedColor, setSelectedColor] = React.useState(fiber.color);
    const [stripeCount, setStripeCount] = React.useState(fiber.stripe_count);
    const [stripeCountError, setStripeCountError] = React.useState(false);
    
    const [showPicker, setShowPicker] = React.useState(false);
    const defaultTextColor = (parseInt(fiber.color.replace('#', ''), 16) > 0xffffff / 2) ? 'black' : 'white';
    const [textColor, setTextColor] = React.useState(defaultTextColor);


    const handleColorChange = (color) => {
        const { hex } = color;
        // Change the text color to contrast the background color
        const contrast = (parseInt(hex.replace('#', ''), 16) > 0xffffff / 2) ? 'black' : 'white';
        setTextColor(contrast);
        setSelectedColor(hex);
    };

    const handleStripeCountSubmit = (newStripeCount) => {
        changeFiberStripeCount(tubeIndex, fiberIndex, newStripeCount);
    };

    const handleStripeCountChange = (e) => {
        const { value } = e.target;

        if (value === '' || value === null || value === undefined) {
            setStripeCount(0);
            handleStripeCountSubmit(0);
            setStripeCountError(false);
            return;
        }
        
        // We need to parse the value to an integer, otherwise the input will be a string
        let numberValue = parseInt(value, 10);

        // Set the value to 0 if the user enters a negative number or a number greater than 99
        if (numberValue < 0) {
            setStripeCountError(true);
            numberValue = 0;
        } else if (numberValue > 99) {
            setStripeCountError(true);
            numberValue = 99;
        } else {
            setStripeCountError(false);
        }

        setStripeCount(numberValue);
        handleStripeCountSubmit(numberValue);
    };

    const handleColorSelect = () => {
        // We need to update the color in the parent component only once the dialog is closed
        changeFiberColor(tubeIndex, fiberIndex, selectedColor);
        setShowPicker(false);
    };

    return (
        <>
            <Box
                style={{ paddingBottom: 10, paddingTop: 10 }}
                gap="small"
                direction="row-responsive"
                align="center"
                justify="center"
            >

                <div>
                    {fiberIndex === 0 && (
                        <Text alignSelf="start" style={{ paddingLeft: '1.8rem' }}>
                            <FormattedMessage
                                id="adminpage-network-infrastructureprovider-color"
                                defaultMessage="Color"
                            />
                            {' '}
                            <RequiredAsterisk />
                        </Text>
                    )}
                    <Box
                        gap="small"
                        direction="row"
                        align="center"
                        justify="center"
                    
                    >
                        <Text style={{ minWidth: 20 }}>{`#${fiber.id}`}</Text>
                        
                        <DropButton
                            label={selectedColor}
                            open={showPicker}
                            onOpen={() => setShowPicker(true)}
                            onClose={handleColorSelect}
                            dropContent={<ChromePicker onChangeComplete={handleColorChange} color={selectedColor} />}
                            dropProps={{ align: { top: 'bottom' } }}
                            style={{
                                backgroundColor: selectedColor,
                                color: textColor,
                            }}
                        />
                    </Box>

                </div>

                <div>
                    {fiberIndex === 0 && (
                        <Text alignSelf="start" style={{ }}>
                            <FormattedMessage
                                id="cable-fiber-lines-count"
                                defaultMessage="Stripes count"
                            />
                            {' '}
                            <RequiredAsterisk />

                        </Text>
                    )}
                    <Box
                        gap="small"
                        direction="row"
                        align="center"
                        justify="center"
                    
                    >
                        <TextInput
                            type="number"
                            min={0}
                            max={99}
                            step="1"
                            // pattern="/[0-9]*/"
                            pattern="\d+"
                            value={stripeCount || 0}
                            onChange={handleStripeCountChange}
                            style={{
                                // Add red border if the value is not a number or more than 100
                                border: stripeCountError ? '1px solid red' : '1px solid #ccc',
                                padding: '6px',
                            }}
                        />


                        <Button
                            style={{ padding: 0 }}
                            icon={<FormSubtract size="medium" />}
                            onClick={() => removeFiberFromTube(tubeIndex, fiberIndex)}
                        />
                    </Box>
                </div>

            </Box>
        </>
    );
};


export default CableFiberColorSchemeField;
